import { useEffect } from 'react'

export default function SEO({ 
  title, 
  description, 
  keywords = 'systemic racism, racial equity, social justice, American history, white privilege, anti-racism, diversity, inclusion, civil rights, racial justice',
  image = '/actual-bookcover.png',
  url = 'https://indoctrination365.com',
  type = 'website',
  structuredData = null
}) {
  useEffect(() => {
    // Set page title
    document.title = title ? `${title} | Indoctri-NATION 365` : 'Indoctri-NATION 365 - A Practical Guide to Dismantling Systemic Racism'
    
    // Set or update meta tags
    const setMeta = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name'
      let element = document.querySelector(`meta[${attr}="${name}"]`)
      if (!element) {
        element = document.createElement('meta')
        element.setAttribute(attr, name)
        document.head.appendChild(element)
      }
      element.setAttribute('content', content)
    }

    // Set or update link tags
    const setLink = (rel, href) => {
      let element = document.querySelector(`link[rel="${rel}"]`)
      if (!element) {
        element = document.createElement('link')
        element.setAttribute('rel', rel)
        document.head.appendChild(element)
      }
      element.setAttribute('href', href)
    }

    // Description and Keywords
    setMeta('description', description)
    setMeta('keywords', keywords)
    
    // Canonical URL
    setLink('canonical', url)
    
    // Open Graph
    setMeta('og:title', title || 'Indoctri-NATION 365', true)
    setMeta('og:description', description, true)
    setMeta('og:image', `${url}${image}`, true)
    setMeta('og:url', url, true)
    setMeta('og:type', type, true)
    setMeta('og:site_name', 'Indoctri-NATION 365', true)
    
    // Twitter Card
    setMeta('twitter:card', 'summary_large_image')
    setMeta('twitter:title', title || 'Indoctri-NATION 365')
    setMeta('twitter:description', description)
    setMeta('twitter:image', `${url}${image}`)
    
    // Structured Data (JSON-LD)
    if (structuredData) {
      let script = document.querySelector('script[type="application/ld+json"]')
      if (!script) {
        script = document.createElement('script')
        script.type = 'application/ld+json'
        document.head.appendChild(script)
      }
      script.textContent = JSON.stringify(structuredData)
    }
  }, [title, description, keywords, image, url, type, structuredData])

  return null
}
